// extracted by mini-css-extract-plugin
export default {"paperTitle":"registration_paperTitle__G11FN"};